import React from 'react';
import { number, string } from 'prop-types';

// Utils
import { convertDataCompanyId, formatVolume } from 'utils/helpers/format';

// Components
import { Box, Typography } from '@mui/material';
import OverflowTypography from './OverflowTypography';

const nameShortStyle = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

const volumeStyle = theme => ({
  color: theme.palette.text.secondary,
  justifySelf: 'flex-end',
});

const AffiliateListItem = props => {
  const { dataCompanyId, nameShort, volume } = props;

  return (
    <Box
      display="grid"
      gridTemplateColumns="1fr 120px"
      gridTemplateRows="1fr 15px"
      justifyContent="space-between"
      paddingBottom={1.5}
      paddingTop={2}
      sx={{
        borderBottom: theme => `1px solid ${theme.palette.graphic.light}`,
      }}
    >
      <OverflowTypography
        text={nameShort}
        typographyProps={{ sx: nameShortStyle, variant: 'body1' }}
      />
      <Typography sx={volumeStyle} variant="body1">
        {formatVolume(volume)} bbls
      </Typography>
      <Typography variant="body2">{convertDataCompanyId(dataCompanyId)}</Typography>
    </Box>
  );
};

AffiliateListItem.propTypes = {
  dataCompanyId: number.isRequired,
  nameShort: string.isRequired,
  volume: number.isRequired,
};

export default AffiliateListItem;
